import React from "react";
import ReactDOM from "react-dom/client";
import "./index.css";
import App from "./App";

import { css, ThemeProvider as EmotionThemeProvider } from "@emotion/react";
import { theme, themeTwo } from "./theme";
import { LanguageProvider } from "./LanguageContext";
import { API_URL, CMS_URL, BEARER_TOKENS, REACT_APP_NEW_THEME } from "./services/config";
import axios from 'axios';
import { FeedbackProvider } from "./context/ui/FeedbackModalContext";

// intercept request flava
axios.interceptors.request.use(request => {
  if (request.url) {
    if (request.url.startsWith(API_URL)) {
      request.headers["Authorization"] = `Token ${localStorage.getItem('userToken') ?? 'anonymous'}`;
    }
    if (request.url.startsWith(CMS_URL)) {
      request.headers["Authorization"] = `Bearer ${BEARER_TOKENS.CMS}`;
    }
  }

  return request;
}, error => {
  return Promise.reject(error);
});

// intercept response flava
axios.interceptors.response.use(response => {
  return response;
}, error => {
  if (error.status == 401) {
    // 401, user must re-login
    return Promise.resolve(error);
  }
  return Promise.reject(error);
});

// continue with app
const root = ReactDOM.createRoot(
  document.getElementById("root") as HTMLElement
);
const hostname = typeof window !== "undefined" ? window.location.hostname : "";

const _theme = hostname.includes(REACT_APP_NEW_THEME) ? themeTwo : theme;

const globalStyle = css`
  background-color: ${_theme.colors.background};
`;


root.render(
  <EmotionThemeProvider theme={_theme}>
    <LanguageProvider>
      <FeedbackProvider>
        <React.StrictMode>
          <App />
        </React.StrictMode>
      </FeedbackProvider>
    </LanguageProvider>
  </EmotionThemeProvider>
);
